 function autoLoader(){const current_url = window.location.pathname;
  
    if (current_url.includes("collections") || current_url.includes("search")) {
      var products_on_page = document.getElementById("product-grid");
      console.log(products_on_page)
      var next_url = products_on_page.getAttribute("data-next-url");
      var loadmore_btn = document.querySelector(".load-more-cstm-btn");
      console.log(next_url)
      function loadMoreProducts() {
        fetch(next_url)
          .then((response) => {
            loadmore_btn.style.display = "none";
            return response.text();
          })
          .then((data) => {
            var parser = new DOMParser();
            var doc = parser.parseFromString(data, "text/html");
            var return_html = doc.body;
            var main_html = return_html.querySelector("#product-grid");
            var main_html_child = main_html.querySelectorAll(".grid__item");
            var new_url = main_html.getAttribute("data-next-url");
            if (new_url) {
              document.querySelector("#product-grid").setAttribute("data-next-url",main_html.getAttribute('data-next-url'))
              loadmore_btn.style.display = "none";
              document.documentElement.classList.remove("loading");
            }
            else{
              document.documentElement.classList.remove("loading");
            }
            next_url = new_url;
            let mainProductWrapper = document.querySelector(".product-grid");
            setTimeout(() => {
              main_html_child.forEach(function (value, index) {             
                document.querySelector(".product-grid").append(value);
              });
              productGridSlider();
              manageAddToBag();
              
              if (new_url) {
                loadmore_btn.style.display = "block";
                document.querySelector('body').classList.remove("loading");  
  
              } else {
                document.querySelector('body').classList.remove("loading");
                loadmore_btn.style.display = "block";
                loadmore_btn.classList.add("ds-no-more-products-left");
                loadmore_btn.classList.add("ds-no-more-products-left");
                loadmore_btn.textContent="No more products";
              }
            }, 600);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    
      if (document.querySelectorAll("#load-more-cstm-btn").length > 0) {
        if (
          document
            .querySelector("#load-more-cstm-btn")
            .classList.contains("ds-no-more-products-left")
        ) {
        } else {
          document
            .querySelector("#load-more-cstm-btn")
            .addEventListener("click", () => {
              setTimeout(loadMoreProducts,500)
            });
        }
      }
      var btnClick = new Event("click");
      document.addEventListener("scroll", function () {
        var collectionTplElm = document.querySelector(".collection_top-wrapper");
        var collectionTop = window.innerHeight;
        var collectionHeight = collectionTplElm.clientHeight;
        var posTop = collectionTop + collectionHeight - window.innerHeight;
    
        if (
          window.pageYOffset > posTop - 1000 &&
          window.pageYOffset < posTop + 1000
        ) {
          if (loadmore_btn) {
            if (loadmore_btn.classList.contains("btn-disabled")) {
            } else {
              loadmore_btn.dispatchEvent(btnClick);
              loadmore_btn.classList.add("btn-disabled");
              setTimeout(function () {
                if (loadmore_btn) {
                  if (loadmore_btn.classList.contains("ds-no-more-products-left")) {
                  } else {
                    loadmore_btn.classList.remove("btn-disabled");
                  }
                }
              }, 3000);
            }
          }
        }
      });
    }
    }autoLoader();
  